export var ResponseCode;
(function (ResponseCode) {
    ResponseCode[ResponseCode["SUCCESS"] = 0] = "SUCCESS";
    ResponseCode[ResponseCode["USER_DENIED"] = 4001] = "USER_DENIED";
    ResponseCode[ResponseCode["ERROR_IN_PARAMS"] = 4002] = "ERROR_IN_PARAMS";
    ResponseCode[ResponseCode["UNKNOWN_METHOD"] = 4003] = "UNKNOWN_METHOD";
    ResponseCode[ResponseCode["UNIMPLEMENTED"] = 4004] = "UNIMPLEMENTED";
    ResponseCode[ResponseCode["UNAUTHENTICATED"] = 4005] = "UNAUTHENTICATED";
    ResponseCode[ResponseCode["TIMEOUT"] = 4006] = "TIMEOUT";
    ResponseCode[ResponseCode["CONTRACT_ERROR"] = 4007] = "CONTRACT_ERROR";
    ResponseCode[ResponseCode["INTERNAL_ERROR"] = 5001] = "INTERNAL_ERROR";
})(ResponseCode || (ResponseCode = {}));
export const ResponseMessagePreset = {
    SUCCESS: 'Success',
    ERROR_IN_PARAMS: 'Please check your params.',
    UNKNOWN_METHOD: 'You are using an unknown method name, please check again.',
    UNIMPLEMENTED: 'This method is not implemented yet.',
    UNAUTHENTICATED: `You are not authenticated, use "requestAccounts" first.`,
    INTERNAL_ERROR: 'Server internal error.',
    TIMEOUT: 'Request timeout.',
    USER_DENIED: 'User denied.',
    CONTRACT_ERROR: 'Request contract fail',
};
export const MethodsBase = {
    CHAIN_ID: 'chainId',
    ACCOUNTS: 'accounts',
    CHAIN_IDS: 'chainIds',
    CA_HASH: 'caHash',
    CHAINS_INFO: 'chainsInfo',
    NETWORK: 'network',
    SEND_TRANSACTION: 'sendTransaction',
    SEND_MULTI_TRANSACTION: 'sendMultiTransaction',
    REQUEST_ACCOUNTS: 'requestAccounts',
    SET_WALLET_CONFIG_OPTIONS: 'setWalletConfigOptions',
};
export const MethodsWallet = {
    GET_WALLET_STATE: 'wallet_getWalletState',
    GET_WALLET_NAME: 'wallet_getWalletName',
    GET_WALLET_SIGNATURE: 'wallet_getSignature',
    GET_WALLET_TRANSACTION_SIGNATURE: 'wallet_getTransactionSignature',
    GET_WALLET_MULTI_TRANSACTION_SIGNATURE: 'wallet_getMultiTransactionSignature',
    GET_WALLET_MANAGER_SIGNATURE: 'wallet_getManagerSignature',
    GET_WALLET_CURRENT_MANAGER_ADDRESS: 'wallet_getCurrentManagerAddress',
    GET_WALLET_MANAGER_SYNC_STATUS: 'wallet_getManagerSyncStatus',
};
//# sourceMappingURL=request.js.map